import moment from 'moment';

export default function sortLignesCommande(lignesCommande) {
  lignesCommande.sort((a, b) => {
    if (moment(a.dateDebut).isBefore(moment(b.dateDebut))) return -1;
    return 1;
  });
}
